if (!customElements.get('mm-bundle-selector-multi-b2g1')) {
  class MMBundleSelectorMultiB2G1 extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.currency = this.dataset.currency || 'GBP';
      this.bundleName = this.dataset.bundleName || 'Bundle';
      this.groupSize = Number(this.dataset.groupSize) || 3;
      this.items = Array.from(this.querySelectorAll('[data-bundle-item]'));
      this.selectedCount = this.querySelector('[data-bundle-selected-count]');
      this.progressText = this.querySelector('[data-bundle-progress-text]');
      this.progressSegments = Array.from(this.querySelectorAll('[data-progress-segment]'));
      this.addButton = this.querySelector('[data-bundle-add]');
      this.buttonLabel = this.querySelector('[data-bundle-button-label]');
      this.pricesOutput = this.querySelector(
  '[data-bundle-prices]'
);
      this.totalOutput = this.querySelector('[data-bundle-total]');
      this.originalTotalOutput = this.querySelector(
  '[data-bundle-original-total]'
);
      this.message = this.querySelector('[data-bundle-message]');
      this.defaultButtonLabel = this.buttonLabel?.textContent.trim() || 'Add to basket';
      this.isAdding = false;

      this.items.forEach((item) => {
        item.querySelector('[data-bundle-select]')?.addEventListener('click', () => {
          if (this.isAdding || item.classList.contains('is-unavailable')) return;
          if (this.getQuantity(item) === 0) this.setQuantity(item, 1);
        });

        item.querySelector('[data-card-remove]')?.addEventListener('click', () => {
          if (!this.isAdding) this.setQuantity(item, 0);
        });

        item.querySelector('[data-card-decrease]')?.addEventListener('click', () => {
          this.changeQuantity(item, -1);
        });

        item.querySelector('[data-card-increase]')?.addEventListener('click', () => {
          this.changeQuantity(item, 1);
        });
      });

      this.addButton?.addEventListener('click', () => this.addToCart());
      this.updateDisplay();
    }

    getQuantity(item) {
      return Number(item.dataset.quantity) || 0;
    }

    getMaximumQuantity(item) {
      const maximum = Number(item.dataset.maxQuantity);
      return Number.isFinite(maximum) ? maximum : 999;
    }

    setQuantity(item, quantity) {
      const safeQuantity = Math.min(
        this.getMaximumQuantity(item),
        Math.max(0, quantity)
      );

      item.dataset.quantity = String(safeQuantity);
      this.clearMessage();
      this.updateDisplay();
    }

    changeQuantity(item, adjustment) {
      if (this.isAdding || item.classList.contains('is-unavailable')) return;
      this.setQuantity(item, this.getQuantity(item) + adjustment);
    }

    getSelectedItems() {
      return this.items.filter((item) => this.getQuantity(item) > 0);
    }

    getTotalQuantity() {
      return this.items.reduce((total, item) => total + this.getQuantity(item), 0);
    }

    getTotalPrice() {
      return this.items.reduce((total, item) => {
        return total + (Number(item.dataset.price) || 0) * this.getQuantity(item);
      }, 0);
    }

    getDiscountedPrice() {
  const individualPrices = [];

  this.items.forEach((item) => {
    const quantity = this.getQuantity(item);
    const price = Number(item.dataset.price) || 0;

    for (let index = 0; index < quantity; index += 1) {
      individualPrices.push(price);
    }
  });

  const originalTotal = individualPrices.reduce(
    (total, price) => total + price,
    0
  );

  const freeItemCount = Math.floor(
    individualPrices.length / this.groupSize
  );

  individualPrices.sort((firstPrice, secondPrice) => {
    return firstPrice - secondPrice;
  });

  const discountAmount = individualPrices
    .slice(0, freeItemCount)
    .reduce(
      (total, price) => total + price,
      0
    );

  return originalTotal - discountAmount;
}

    formatMoney(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency',
          currency: this.currency,
        }).format(cents / 100);
      } catch (error) {
        return `£${(cents / 100).toFixed(2)}`;
      }
    }

    updateProgress(totalQuantity) {
  if (this.selectedCount) {
    this.selectedCount.textContent =
      `${totalQuantity} selected`;
  }

  const remainder = totalQuantity % this.groupSize;
  const completedGroup =
    totalQuantity > 0 && remainder === 0;

  const filledSegments = completedGroup
    ? this.groupSize
    : remainder;

  this.progressSegments.forEach((segment, index) => {
    segment.classList.toggle(
      'is-filled',
      index < filledSegments
    );
  });

  if (!this.progressText) return;

  if (totalQuantity === 0) {
    this.progressText.textContent =
      'Add 2 more kits to unlock your free kit';
  } else if (remainder === 1) {
    this.progressText.textContent =
      'Add 1 more kit to unlock your free kit';
  } else if (remainder === 2) {
    this.progressText.textContent =
      'Now add your free kit';
  } else {
    this.progressText.textContent =
      'Your free kit is unlocked!';
  }
}

    updateDisplay() {
      this.items.forEach((item) => {
        const quantity = this.getQuantity(item);
        const maximum = this.getMaximumQuantity(item);
        const isSelected = quantity > 0;
        const isUnavailable = item.classList.contains('is-unavailable');
        const selectButton = item.querySelector('[data-bundle-select]');
        const removeButton = item.querySelector('[data-card-remove]');
        const countBadge = item.querySelector('[data-card-count]');
        const controls = item.querySelector('[data-card-controls]');
        const output = item.querySelector('[data-card-output]');
        const decreaseButton = item.querySelector('[data-card-decrease]');
        const increaseButton = item.querySelector('[data-card-increase]');

        item.classList.toggle('is-selected', isSelected);
        selectButton?.setAttribute('aria-pressed', String(isSelected));

        if (selectButton) selectButton.disabled = isUnavailable || this.isAdding;

        if (removeButton) {
          removeButton.hidden = !isSelected;
          removeButton.disabled = this.isAdding;
        }

        if (countBadge) {
          countBadge.hidden = !isSelected;
          countBadge.textContent = String(quantity);
        }

        if (controls) controls.hidden = !isSelected;
        if (output) output.textContent = String(quantity);
        if (decreaseButton) decreaseButton.disabled = !isSelected || this.isAdding;
        if (increaseButton) increaseButton.disabled = isUnavailable || quantity >= maximum || this.isAdding;
      });

      const totalQuantity = this.getTotalQuantity();

if (this.buttonLabel) {
  if (this.isAdding) {
    this.buttonLabel.textContent = 'ADDING…';
  } else if (totalQuantity === 0) {
    this.buttonLabel.textContent = 'SELECT A KIT';
  } else {
    this.buttonLabel.textContent = this.defaultButtonLabel;
  }
}

if (this.pricesOutput) {
  this.pricesOutput.hidden = totalQuantity === 0;
}

this.updateProgress(totalQuantity);

      const originalTotal = this.getTotalPrice();
const discountedTotal = this.getDiscountedPrice();
const hasDiscount = discountedTotal < originalTotal;

if (this.totalOutput) {
  this.totalOutput.textContent =
    this.formatMoney(discountedTotal);
}

if (this.originalTotalOutput) {
  this.originalTotalOutput.textContent =
    this.formatMoney(originalTotal);

  this.originalTotalOutput.hidden = !hasDiscount;
}

      if (this.addButton) {
        this.addButton.disabled = totalQuantity < 1 || this.isAdding;
      }
    }

    async addToCart() {
      if (this.isAdding) return;
      const selectedItems = this.getSelectedItems();
      if (selectedItems.length === 0) return;

      this.isAdding = true;
      this.clearMessage();
      if (this.buttonLabel) this.buttonLabel.textContent = 'ADDING…';
      this.addButton?.classList.add('is-loading');
      this.updateDisplay();

      const items = selectedItems.map((item) => ({
        id: Number(item.dataset.variantId),
        quantity: this.getQuantity(item),
        properties: {
          _bundle_name: this.bundleName,
          _bundle_offer: 'Buy 2 get 1 free',
        },
      }));

      const totalQuantity = this.getTotalQuantity();
      const baseUrl = this.dataset.cartAddUrl || '/cart/add';
      const cartAddUrl = baseUrl.endsWith('.js') ? baseUrl : `${baseUrl}.js`;

      try {
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items }),
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description || result.message || 'The selected kits could not be added.'
          );
        }

        this.items.forEach((item) => {
          item.dataset.quantity = '0';
        });

        this.showMessage(
          totalQuantity === 1
            ? '1 kit added to your cart.'
            : `${totalQuantity} kits added to your cart.`
        );

        this.refreshAndOpenRebuy();
      } catch (error) {
        this.showMessage(
          error.message || 'The selected kits could not be added.',
          true
        );
      } finally {
        this.isAdding = false;
        if (this.buttonLabel) this.buttonLabel.textContent = this.defaultButtonLabel;
        this.addButton?.classList.remove('is-loading');
        this.updateDisplay();
      }
    }

    refreshAndOpenRebuy() {
      if (window.Rebuy?.Cart?.fetchShopifyCart) {
        window.Rebuy.Cart.fetchShopifyCart(() => {
          window.Rebuy?.SmartCart?.show?.();
        });
        return;
      }

      window.Rebuy?.SmartCart?.show?.();
    }

    clearMessage() {
      if (!this.message) return;
      this.message.textContent = '';
      this.message.classList.remove('is-error');
    }

    showMessage(text, isError = false) {
      if (!this.message) return;
      this.message.textContent = text;
      this.message.classList.toggle('is-error', isError);
    }
  }

  customElements.define(
    'mm-bundle-selector-multi-b2g1',
    MMBundleSelectorMultiB2G1
  );
}